export const AD_FORMATS = {
  APP_ONLY: 'App Only',
  DISPLAY: 'Cross-Platform Display',
  SEARCH: 'Cross-Platform Search',
  PRODUCT: 'Cross-Platform Product',
};

export const SECONDARY_AD_FORMATS = {
  FACEBOOK: {
    [AD_FORMATS.APP_ONLY]: ['App Engagement Ads', 'App Install Ads'],
  },
  OTHER: {},
};

export const OS_TYPES = {
  ANDROID: 'Android',
  IOS: 'iOS',
};

export const IMPRESSION_PARAM_BLACKLIST = [
  '$link_title',
  '$one_time_use',
  '+url',
  '~id',
  '~advertising_partner_name',
  '~os_type',
  '$always_deeplink',
  '$android_deeplink_path',
  '$android_passive_deepview',
  '$android_redirect_timeout',
  '$android_wechat_url',
  '$blackberry_ur',
  '$click_conversion_window_days',
  '$click_install_window_days',
  '$click_session_start_window_days',
  '$custom_sms_text',
  '$deeplink_no_attribution',
  '$deeplink_path',
  '$desktop_deeplink_path',
  '$do_not_process',
  '$fallback_url',
  '$fire_url',
  '$ios_deeplink_path',
  '$ios_passive_deepview',
  '$ios_redirect_timeout',
  '$ios_wechat_url',
  '$ipad_url',
  '$match_duration',
  '$og_image_height',
  '$og_image_width',
  '$og_redirect',
  '$og_type',
  '$og_url',
  '$og_video',
  '$publicly_indexable',
  '$samsung_url',
  '$twitter_app_country',
  '$twitter_card',
  '$twitter_player_height',
  '$twitter_player_width',
  '$twitter_player',
  '$twitter_site',
  '$uri_redirect_mode',
  '$web_only',
  '$windows_phone_url',
  '~creation_source',
];
